<!--
 * @Author: Src
 * @Date: 2024-12-17 19:09:43
 * @LastEditTime: 2025-11-20 09:58:20
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/views/shop/AddShop.vue
 * @Description: 头部注释配置模板
-->
<template>
    <div>
        <TopTitle>
            <template #left>
                <div>
                    <el-button type="text" @click="back">返回</el-button>
                </div>
            </template>
            <template #center>
                <div>添加店铺</div>
            </template>
        </TopTitle>
        <BooyComponent>
            <el-form :model="form" label-width="140px" ref="ruleForm" :rules="rules" l>
                <el-form-item v-for="item in initShopFields" :key="item.label" :label="item.labelName"
                    :prop="item.label" label-width="140px">
                    <component v-model="form[item.label]" :is="getComponent(item.label)" :disabledType="item.readonly"
                        @change="change(item.label, $event)" :regions="citys" :CityId="form.adcode"
                        @changeShop="changeShop">
                    </component>
                </el-form-item>
            </el-form>
            <div class="submit-btn">
                <el-button type="primary" @click="submitForm" class="submit-INbtn">提交</el-button>
            </div>
        </BooyComponent>
    </div>
</template>
<script lang="ts">
import { Vue, Component, Ref } from 'vue-property-decorator';
import { IShop } from '@/common/interface/shop';
import { ShopFieldFactory } from '@/models/shopFieldFactory';
import CityField from '@/views/shop/comments/CityField.vue';
import InputField from '@/views/shop/comments/InputField.vue';
import UploadField from '@/views/shop/comments/UploadField.vue';
import PickerField from '@/views/shop/comments/PickerField.vue';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
import shopNameField from '@/views/shop/comments/shopNameField.vue';
import TimePickerField from '@/views/shop/comments/TimePickerField.vue';
import { EShopField } from '@/common/enum/shop';
import TopTitle from '@/components/topTitle.vue';
import BooyComponent from '@/components/booyComponent.vue';
import { Form } from 'element-ui';
interface City {
    code: string; // 城市编号
    depth: number;
    id: number; // 城市id
    name: string;
    pid?: number;
    pinyin: string;
    pinyin2: string;
    province?: City;
}

@Component({
    components: {
        TopTitle,
        BooyComponent
    }
})
export default class AddShop extends Vue {
    form: { [key: string]: any } | any = {};

    @Ref('ruleForm')
    ruleForm!: any;
    
    citys: City[] = [];

    regions: Array<{ id: number; name: string; city: City[] }> = [];

    @lazyInject(ShopService)
    shopService!: ShopService;

    rules: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        [k: string]: any[];
    } = {};

    initShopFields: IShop[] = ShopFieldFactory.init();

    mounted() {

        this.getCityList();
    }


    async getCityList() {
        const response = (await this.shopService.getCityList()) as unknown as {
            [key: string]: {
                province: City;
                city: City[];
            };
        };
        if (response) {
            const citys = Object.values(response)
                .map((item) => item.city)
                .reduce((prev, cur) => prev.concat(cur), []);
            this.citys = citys;

            const all = Object.values(response);
            const list: Array<{ id: number; name: string; city: City[] }> = [];
            for (const province of all) {
                list.push({
                    city: province.city,
                    id: province.province ? province.province.id : 0,
                    name: province.province ? province.province.name : '直辖市',
                });
            }
            this.regions = [...list];
        } else {
            this.citys = [];
        }
        // console.log(this.regions, this.citys);
    }

    getData() {
        this.getPoi(this.regions[0].id, this.regions[0].name);
    }

    back() {
        this.$router.push('/shop/list');
    }

    async getPoi(regionId: any, keywords: any) {
        const response = (await this.shopService.getPoi(regionId, keywords)) as unknown as any;
        // console.log(response);
    }

    setRulesAndFormItems(fields: IShop[]) {

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const rules: any = {};
        for (const field of fields) {
            rules[field.label] =
                field.rule && field.rule.length ? field.rule : undefined;
        }

        const ruleKeys = Object.keys(rules);
        for (const key of ruleKeys) {
            if (rules[key] === undefined) {
                delete rules[key];
            }
        }
        this.rules = rules;
    }

    getComponent(label: string) {
        // console.log(label);
        switch (label) {
            case EShopField.city:
                return CityField;
            case EShopField.nationalEmblemPhotos:
                return UploadField;
            case EShopField.businessYear:
                return PickerField;
            case EShopField.portraitPhotos:
                return UploadField;
            case EShopField.shopLicense:
                return UploadField;
            case EShopField.shopName:
                return shopNameField;
            case EShopField.businessHours:
                return TimePickerField;
            default:
                return InputField;
        }
    }
    change(label: string, value: string, shop?: any) {
        // console.log(label, value);
        if (label === EShopField.businessHours) {
            const [startTime, endTime] = value.split('-');
            let _sd = '08:00';
            let _ed = '20:00';
            if ((new Date(startTime) as any) == 'Invalid Date') {
                _sd = startTime;
            } else {
                const _date = new Date(startTime);
                const _hours = _date.getHours() > 9 ? _date.getHours() : `0${_date.getHours()}`
                const _minutes = _date.getMinutes() > 9 ? _date.getMinutes() : `0${_date.getMinutes()}`
                _sd = `${_hours}:${_minutes}`;
            }
            if (new Date(endTime) as any == 'Invalid Date') {
                _ed = endTime;
            } else {
                const _date = new Date(endTime);
                const _hours = _date.getHours() > 9 ? _date.getHours() : `0${_date.getHours()}`
                const _minutes = _date.getMinutes() > 9 ? _date.getMinutes() : `0${_date.getMinutes()}`
                _ed = `${_hours}:${_minutes}`;
            }
            this.form[label] = `${_sd}-${_ed}`;
        } else {
            this.form[label] = value;
        }
        // if (label === EShopField.shopName) {
        //     console.log(shop);
        //     this.form.poi = shop.id;
        // }
        // console.log(this.form);
    }

    changeShop(shop: any) {
        this.form.poi = shop.id;
        this.form.poiName = shop.name;
    }
    submitForm() {
        this.rules = {};
        // this.ruleForm.resetFields();
        this.setRulesAndFormItems(this.initShopFields);
        this.ruleForm.validate((valid: boolean) => {
            if (valid) {
                // console.log('submit!');

                console.log(this.form);
                if (this.form.poi) {
                    this.addShop();
                }
            } else {
                console.log('error submit!!');
                return false;
            }
        });
    }

    async addShop() {
        this.form.ka_id = localStorage.getItem('brandcode') as string;
        this.form.latitude = '0';
        this.form.longitude = '0';
        const response = await this.shopService.addShop(this.form);
        if (response) {
            this.$router.push('/shop/list');
        }
    }

}
</script>
<style lang="scss" scoped>
.submit-btn {
    text-align: center;
    margin-top: 20px;

    .submit-INbtn {
        width: 200px;
    }
}
</style>
